import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Instructions_ds_instruction_types_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { fullTextSearch?: string, typeIds?: number[] }): 
  Promise<{ result: { Id?: number, Name?: string }[] }> 
  {
    let url = `${environment.backendUrl}api/Instructions/datasources/ds_instruction_types_dd/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { fullTextSearch?: string, typeIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Name?: string }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Instructions/datasources/ds_instruction_types_dd/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { fullTextSearch?: string, typeIds?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, Name?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Instructions/datasources/ds_instruction_types_dd/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      fullTextSearch?: string, typeIds?: number[]    }) {
      return false;
    }
}
